import "./Assets/FontAwesomePro/css/all.css"
import Pages from "./Pages";
import "./App.css";
import "./style.scss";


// import "react-tabulator/lib/css/tabulator_bootstrap4.min.css";
// import 'react-tabulator/lib/css/tabulator.css';
// import 'react-tabulator/lib/css/tabulator_modern.css';
// import 'react-tabulator/lib/css/tabulator_simple.css';
// import 'react-tabulator/lib/css/tabulator_semanticui.css';
import "../src/Assets/css/tabulatorTheme.scss"
import {addApiUrlToLocalStorage} from "./utils/utilsData";
import {useEffect} from "react";
import ErrorHandler from "./Components/ErrorHandler";
import "./Assets/css/input__label.scss"


function App() {
  useEffect(() => {
    addApiUrlToLocalStorage()
  }, [])
  return (
    <ErrorHandler>
      <Pages/>
    </ErrorHandler>
  );
}

export default App;